import type { SVGProps } from 'react';

type VolatilityInfoIconProps = SVGProps<SVGSVGElement> & {
    fill?: string;
};

export const VolatilityInfoIcon = ({
    fill = '#ffffff',
    width = 16,
    height = 16,
    ...svgProps
}: VolatilityInfoIconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 12.0272C7.5 11.7511 7.72386 11.5272 8 11.5272C8.27614 11.5272 8.5 11.7511 8.5 12.0272C8.5 12.3034 8.27614 12.5272 8 12.5272C7.72386 12.5272 7.5 12.3034 7.5 12.0272Z"
            fill={fill}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.34141 4.53363C8.00194 4.4661 7.65007 4.50076 7.3303 4.63321C7.01053 4.76567 6.73722 4.98997 6.54493 5.27775C6.35264 5.56554 6.25 5.90388 6.25 6.25C6.25 6.52614 6.02614 6.75 5.75 6.75C5.47386 6.75 5.25 6.52614 5.25 6.25C5.25 5.7061 5.41128 5.17442 5.71346 4.72218C6.01563 4.26995 6.44512 3.91747 6.94762 3.70933C7.45012 3.50119 8.00305 3.44673 8.5365 3.55284C9.06994 3.65895 9.55995 3.92086 9.94454 4.30546C10.3291 4.69005 10.591 5.18005 10.6972 5.7135C10.8033 6.24695 10.7488 6.79988 10.5407 7.30238C10.3325 7.80488 9.98005 8.23437 9.52782 8.53654C9.21569 8.7451 8.86572 8.88654 8.5 8.95416V10C8.5 10.2761 8.27614 10.5 8 10.5C7.72386 10.5 7.5 10.2761 7.5 10V8.5C7.5 8.22386 7.72386 8 8 8C8.34612 8 8.68446 7.89736 8.97225 7.70507C9.26003 7.51278 9.48434 7.23947 9.61679 6.9197C9.74924 6.59993 9.7839 6.24806 9.71637 5.90859C9.64885 5.56913 9.48218 5.25731 9.23744 5.01256C8.99269 4.76782 8.68087 4.60115 8.34141 4.53363Z"
            fill={fill}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
            fill={fill}
        />
    </svg>
);

export default VolatilityInfoIcon;
